import React, { useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import "../../../src/styles/admin_user_nav.css";
import {
  DuplicateApprovalEntityRequest,
  getImageData,
  getPdfData,
} from "../../postExaminationProcessObjective/actions/postExaminationProcessObjectiveActions";
import { toastr } from "react-redux-toastr";
import { Image } from "antd";

const FileViewModal = (props) => {
  const dispatch = useDispatch();
  let [selectedEntity, setSelectedEntity] = useState();
  let { fileObject } = useSelector(
    (state) => state.postExamProcessObjectReducer,
    shallowEqual
  );
  function isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
  }
  useEffect(() => {
    if (props.setSelectedApprovalEntity) {
      props.fileType === 'pdf' && dispatch(getPdfData(props.selectedExam, props.selectedSubject, props.venueName));
      props.fileType !== 'pdf' && dispatch(getImageData(props.setSelectedApprovalEntity));
    }
  }, [dispatch, selectedEntity]);



  const onSubmit = (data) => {

    // dispatch(DuplicateApprovalEntityRequest(requestBody,));
    let details = JSON.parse(
      selectedEntity.entityApprovalAction.entityApprovalDto.detail
    );
    selectedEntity.entityApprovalAction.entityApprovalDto.detail = details;

    setSelectedEntity(selectedEntity);
  };



  return (
    <Modal
      size="xl"
      show={props.showModal}
      onHide={() => {
        props.setShowModal(false);
      }}
      aria-labelledby="example-modal-sizes-title-xl"
      backdrop="static"
    >
      <form>
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-xl"></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {props.fileType !== "pdf" &&
            <div className="center-half" > <img src={`data:image/png;base64,${fileObject}`} width="100%" alt="file" /></div>}
          {props.fileType === "pdf" && <div className="row">
            <div className="col-md-12">
              <embed
                className="emb-sz w-100 mh-500"
                src={`data:application/pdf;base64,${fileObject.image}`}
              ></embed>
            </div>
          </div>}
        </Modal.Body>
      </form>
    </Modal>
  );
};
export default FileViewModal;
